import logo from '@/assets/images/logo.png'

export const APP_NAME    = 'Klauch'
export const APP_DOMAIN  = 'Klauch.com'
export const APP_TAGLINE = 'Bulk SMS · WhatsApp · VTU'
export const APP_LOGO    = logo
export const APP_DESC    = 'The all-in-one messaging platform for African businesses — SMS, WhatsApp, automation, and more.'

// Feature flags — set to true to re-enable.
export const FEATURES = {
  whatsapp: false,
}
